var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.96 19.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3d3d3d;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-close",
    "data-name": "Icon material-close",
    className: "cls-1",
    d: "m19.96,2.01l-2.01-2.01-7.97,7.97L2.01,0,0,2.01l7.97,7.97L0,17.95l2.01,2.01,7.97-7.97,7.97,7.97,2.01-2.01-7.97-7.97,7.97-7.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/Cross-icon.8534fbf32927c3005fd30ce36318b58e.svg";
export { ForwardRef as ReactComponent };